import { render, staticRenderFns } from "./SlideOverview.vue?vue&type=template&id=397edc34&scoped=true&"
import script from "./SlideOverview.vue?vue&type=script&lang=js&"
export * from "./SlideOverview.vue?vue&type=script&lang=js&"
import style0 from "./SlideOverview.vue?vue&type=style&index=0&id=397edc34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397edc34",
  null
  
)

export default component.exports